import { useEffect, useState } from 'react';

const useAccordionControl = (isSearching) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (isSearching == undefined) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [isSearching]);
  const handleAccordionChange = (e, shouldExpand) => {
    setExpanded(shouldExpand);
  };
  return [expanded, handleAccordionChange];
};

export default useAccordionControl;
